import { store } from '@/decorators/store';
import { Ete } from '@/entities/Ete';
import { AbstractEntityStore } from '@/stores/AbstractEntityStore';

@store({ id: 'EteStore' })
export class EteStore extends AbstractEntityStore<Ete> {
  protected entityIdKey = 'tripId';
}
